import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FilterIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <g clipPath="url(#filter_icon_svg__clip0_19786_47192)">
            <path fillRule="evenodd"
                clipRule="evenodd"
                d="M5.2 2.219a1.583 1.583 0 1 0 0 3.166 1.583 1.583 0 0 0 0-3.166Zm-2.991.833a3.085 3.085 0 0 1 6.074.75 3.083 3.083 0 0 1-6.074.75H1a.75.75 0 1 1 0-1.5h1.209Zm7.374.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-4.667a.75.75 0 0 1-.75-.75ZM10.8 10.62a1.583 1.583 0 1 0 0 3.166 1.583 1.583 0 0 0 0-3.166Zm-3.083 1.583a3.083 3.083 0 0 1 6.074-.75H15a.75.75 0 0 1 0 1.5h-1.209a3.085 3.085 0 0 1-6.074-.75Zm-7.467 0a.75.75 0 0 1 .75-.75h4.667a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1-.75-.75Z"/>
        </g>
    </svg>
);
FilterIcon.displayName = 'FilterIcon';
export default FilterIcon;
